import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const BookkeeperShow = ({ item, handleClose }) => (
  <>
    <Modal.Body>
      <div className="info-box">
        {item.code && (
          <p className="info">
            <span>Código:</span> {item.code}
          </p>
        )}
        {item.name && (
          <p className="info">
            <span>Concepto:</span> {item.name}
          </p>
        )}
        {item.account && (
          <p className="info">
            <span>Cuenta Contable:</span> {item.account}
          </p>
        )}

        {item.major_account && (
          <p className="info">
            <span>Cuenta Mayor:</span> {item.major_account}
          </p>
        )}

        {item.record_type && (
          <p className="info">
            <span>Condición:</span> {item?.condition_name}
          </p>
        )}
        <p className="info">
          <span>Imputación:</span> {item.translated_imputation}
        </p>
        <p className="info">
          <span>Distribución:</span> {item.translated_distribution}
        </p>
        <p className="info">
          <span>Agrupado:</span> {item.translated_grouped}
        </p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-info" onClick={handleClose}>
        Cerrar
      </Button>
    </Modal.Footer>
  </>
);

export default BookkeeperShow;
